/**
 * Extracts initials from a full name (first letter of first and last name)
 */
export function getInitials(name: string): string {
    const parts = name.trim().split(/\s+/).filter(Boolean);

    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0][0].toUpperCase();

    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/**
 * Generates a deterministic color from a string (email/ID)
 * Same input always produces the same color
 */
export function getAvatarColor(seed: string): string {
    // Predefined palette of pleasant, accessible colors
    const colors = [
        'bg-blue-500',
        'bg-green-500',
        'bg-purple-500',
        'bg-pink-500',
        'bg-orange-500',
        'bg-cyan-500',
        'bg-indigo-500',
        'bg-teal-500',
        'bg-rose-500',
        'bg-amber-500',
    ];

    // Simple hash function for deterministic color selection
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }

    const index = Math.abs(hash) % colors.length;
    return colors[index];
}
